const TokenKey = 'DULWICH-MOCK-TOKEN'
const LastPageKey = 'DULWICH-MOCK-LAST-PAGE'
const LanguageKey = 'language' // TODO: 命名统一
const LevelTypeKey = 'LevelType' // TODO: 命名统一
const LevelActiveKey = 'LevelActive' // TODO: 命名统一
const LevelActiveIndexKey = 'LevelActiveId' // TODO: 命名统一
const signKey = 'DULWICH-MOCK-SINGNKEY' // TODO: 命名统一
const ssoMark = 'SSO_LOGIN_MARKED' // TODO: 命名统一
const Role = 'DULWICH-MOCK-ROLE'
const localStorage = window.localStorage
const sessionStorage = window.sessionStorage

// 本地存储登录token（localStorage：浏览器内部共享）
function getToken() {
  return localStorage.getItem(TokenKey)
}
function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}
function removeToken() {
  return localStorage.removeItem(TokenKey)
}

// 本地缓存登录之前页面
function getLastPage() {
  return sessionStorage.getItem(LastPageKey)
}
function setLastPage(page) {
  return sessionStorage.setItem(LastPageKey, page)
}
function removeLastPage() {
  return sessionStorage.removeItem(LastPageKey)
}

// 本地缓存语言
function getLanguage() {
  return localStorage.getItem(LanguageKey)
}
function setLanguage(language) {
  return localStorage.setItem(LanguageKey, language)
}
function removeLanguage() {
  return localStorage.removeItem(LanguageKey)
}

// 本地缓存等级类型
function getLevelType() {
  return localStorage.getItem(LevelTypeKey)
}
function setLevelType(levelType) {
  return localStorage.setItem(LevelTypeKey, levelType)
}

// 本地缓存等级选择
function getLevelActive() {
  return Number(localStorage.getItem(LevelActiveKey))
}
function setLevelActive(levelActive) {
  return localStorage.setItem(LevelActiveKey, levelActive)
}

// 本地缓存等级选择
function getLevelActiveIndex() {
  return localStorage.getItem(LevelActiveIndexKey)
}
function setLevelActiveIndex(levelActiveIndex) {
  return localStorage.setItem(LevelActiveIndexKey, levelActiveIndex)
}

// 本地存储登录token（localStorage：浏览器内部共享）
function getSignKey() {
  return localStorage.getItem(signKey)
}
function setSignKey(key) {
  return localStorage.setItem(signKey, key)
}
function removeSignKey() {
  return localStorage.removeItem(signKey)
}

// 本地存储用户角色
function getUserRole() {
  return localStorage.getItem(Role)
}
function setUserRole(val) {
  return localStorage.setItem(Role,val)
}

function removeUserRole() {
  return sessionStorage.removeItem(Role)
}

export {
  getToken,
  setToken,
  removeToken,
  getLastPage,
  setLastPage,
  removeLastPage,
  getLanguage,
  setLanguage,
  removeLanguage,
  getLevelType,
  setLevelType,
  getLevelActive,
  setLevelActive,
  getLevelActiveIndex,
  setLevelActiveIndex,
  getSignKey,
  setSignKey,
  removeSignKey,
  getUserRole,
  setUserRole,
  removeUserRole
}
